// extracted by mini-css-extract-plugin
module.exports = {"header":"ITblpoov","topRow":"FV6KbT8b","headerContent":"xuIgrKNo","titleText":"b8CHDghS","subtitleSmall":"Owtd_D1d","bodySmall":"feyDiMO8"};